import { type LucideIcon, icons } from 'lucide-react'
import { cn } from '@/lib/utils'

export type IconName = keyof typeof icons

const sizeMap = {
	sm: 16,
	md: 20,
	lg: 24,
} as const

type IconSize = keyof typeof sizeMap

interface IconProps {
	name: IconName
	size?: IconSize | number
	className?: string
}

export function Icon({ name, size = 'md', className }: IconProps) {
	const LucideIcon: LucideIcon = icons[name]
	const px = typeof size === 'number' ? size : sizeMap[size]

	return <LucideIcon width={px} height={px} className={cn(className)} />
}
